import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Select, Heading, Text } from '@chakra-ui/react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const ViewQuestionsByCategory = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`);
        setCategories(response.data.$values || response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;
    setSelectedCategory(categoryId);
    if (categoryId) {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/QuestionCategories/category/${categoryId}`);
        const questionsData = response.data.$values || response.data;
        setQuestions(questionsData);
        setTotalCount(questionsData.length);
      } catch (error) {
        console.error('Error fetching questions:', error);
        setQuestions([]);
        setTotalCount(0);
      }
    } else {
      setQuestions([]);
      setTotalCount(0);
    }
  };

  const columnDefs = [
    { headerName: 'Serial No', valueGetter: 'node.rowIndex + 1', width: 80 },
    { headerName: 'Question ID', field: 'questionId', sortable: true, filter: true, width: 100 },
    { headerName: 'Question Text', field: 'questionText', sortable: true, filter: true, flex: 1, minWidth: 200 },
    {
      headerName: 'Correct Answer',
      valueGetter: (params) => {
        const correctOption = params.data.options.$values.find((option) => option.isCorrect);
        return correctOption ? correctOption.optionText : 'N/A';
      },
      sortable: true,
      filter: true,
      width: 150
    }
  ];

  const defaultColDef = {
    flex: 1,
    minWidth: 100,
    resizable: true,
    sortable: true,
    filter: true,
    floatingFilter: true,
  };

  return (
    <Box p={8}>
      <Heading mb={6}>View Questions by Category</Heading>
      <Select placeholder="Select Category" onChange={handleCategoryChange} mb={4}>
        {categories.map((category) => (
          <option key={category.categoryId} value={category.categoryId}>
            {category.categoryName}
          </option>
        ))}
      </Select>
      <Text mb={4}>Total Questions: {totalCount}</Text>
      <div className="ag-theme-alpine" style={{ height: '400px', width: '100%' }}>
        <AgGridReact columnDefs={columnDefs} rowData={questions} defaultColDef={defaultColDef} />
      </div>
    </Box>
  );
};

export default ViewQuestionsByCategory;
